import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { NoRooms, EmptyStateIcon } from '../styles/MainMenu.styles'
import { AuthMessages } from '../AuthenticationDialog.messages'
import { useAppSelector } from '../../hooks'
import { signupWaitlistUrl } from '../../utils/signupWaitlist'

interface SignupClosedNoticeProps {
  /** When set, a Back button leads out, like the company views this notice stands in for. */
  onBack?: () => void
}

/**
 * Shown in place of the Create Company form while Registration Mode is Closed: during the
 * go-to-market waitlist cloud refuses self-serve company creation, so the form would only fail
 * on submit. Points to the admin's waitlist page instead. [SC-443]
 */
export default function SignupClosedNotice({ onBack }: SignupClosedNoticeProps = {}) {
  const waitlistUrl = useAppSelector((state) => signupWaitlistUrl(state.workspace.settings))

  const notice = (
    <NoRooms data-testid="signup-closed-notice">
      <EmptyStateIcon>
        <AddCircleIcon fontSize="inherit" />
      </EmptyStateIcon>
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {AuthMessages.SIGNUP_CLOSED_NOTICE}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component="a"
        href={waitlistUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${AuthMessages.SIGNUP_WAITLIST_CTA} ${AuthMessages.OPENS_IN_NEW_TAB}`}
        endIcon={<OpenInNewIcon aria-hidden />}
        sx={{ mt: 2, textTransform: 'none' }}
      >
        {AuthMessages.SIGNUP_WAITLIST_CTA}
      </Button>
    </NoRooms>
  )

  if (!onBack) return notice

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Button onClick={onBack} startIcon={<ArrowBackIcon />} variant="outlined">
          Back
        </Button>
      </Box>
      {notice}
    </Box>
  )
}
